// src/ImageCacheContext.js
import React, {createContext, useContext, useState} from 'react';
import Geto from 'util/Geto';

const ImageCacheContext = createContext();

export const ImageCacheProvider = ({children}) => {
    const [imageGeto] = useState(new Geto(true));
    const [profileGeto] = useState(new Geto(false));

    return (
        <ImageCacheContext.Provider value={{imageGeto, profileGeto}}>
            {children}
        </ImageCacheContext.Provider>
    );
};

export const useImageCache = () => useContext(ImageCacheContext);
